export const supportLanguagesMessages = [
  'javascript',
  'typescript',
  'python',
  'java',
  'js',
  'php',
  'css',
  'html',
  'jsx',
  'rust',
  'go',
  'bash',
  'cpp',
  'ruby',
  'swift',
  'php',
  'sql',
  'markdown',
];

export const highlightWordsTextArea = [
  {
    word: /\$\{(\w+)\}/g,
    classnames: 'bg-lavender text-nue-blue rounded-md py-1 px-2',
  },
  {
    word: /"'(.+?)'"/gs,
    classnames: 'bg-lavender text-nue-blue rounded-md py-1 px-2',
  },
];

export const highlightWordsTextAreaV2 = [
  {
    highlight: /\$\{(\w+)\}/g,
    className: 'bg-lavender text-nue-blue rounded-md py-[2px]',
    prefix: ' ',
    suffix: ' ',
  },
  {
    highlight: /""'(.+?)'""/gs,
    className: 'bg-lavender text-nue-blue rounded-md px-[3px] py-[2px]',
    prefix: `   `,
    suffix: `   `,
  },
  {
    highlight: /"'(.+?)'"/gs,
    className: 'bg-lavender text-nue-blue rounded-md px-[2px] py-[2px]',
    prefix: `  `,
    suffix: `  `,
  },
];

export const highlightWordsTextAreaV2Dark = [
  {
    highlight: /\$\{(\w+)\}/g,
    className: 'bg-ship-grey text-powder-blue rounded-md py-[2px]',
    prefix: ' ',
    suffix: ' ',
  },
  {
    highlight: /""'(.+?)'""/gs,
    className: 'bg-ship-grey text-powder-blue rounded-md px-[3px] py-[2px]',
    prefix: `   `,
    suffix: `   `,
  },
  {
    highlight: /"'(.+?)'"/gs,
    className: 'bg-ship-grey text-powder-blue rounded-md px-[2px] py-[2px]',
    prefix: `  `,
    suffix: `  `,
  },
];

export const modelLabels = {
  'gpt-3.5-turbo': 'gpt-3.5',
  'gpt-4': 'gpt-4',
};

export const MAX_TITLE_LENGTH = 85;

export const svgIconBase64 = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAyNyAzNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjYuNSA4LjVIMTkuMjc3NkwyMy42MTA5IDBIMTIuMDU1OEwwLjUgMjIuNjY2NEg5LjE2NjY3VjM0TDI2LjUgOC41WiIgZmlsbD0iaW5oZXJpdCIvPjwvc3ZnPg==`;

export const IMAGES_TEMPLATES_IDS = {
  DALLE: '65805947d92e370a3d5625c6',
  FLUX: '66c786d7e26442bc593e575d',
};

export const DEFAULT_OPTIONS_CHAT_TOOLBAR = [
  { name: 'New Chat', isHidden: false },
  { name: 'Select Model', isHidden: false },
  { name: 'Text To Speech', isHidden: false },
  { name: 'Open prompt templates menu', isHidden: false },
  { name: 'Clear Chat', isHidden: false },
];
